<template>
  <v-card color="transparent">
    <div class="text-center">
      <div class="text-h5 font-weight-bold">
        {{ $t('ARTWORK.EDIT.WORD.DISPLAY_SETTINGS') }}
      </div>
      <div>
        {{
          $t('ARTWORK.EDIT.COPYWRITING.PLEASE_SELECT_FRAME_AND_IMAGE_TO_UPLOAD')
        }}
      </div>
    </div>

    <v-card-text>
      <template v-if="type === '3dmodel'">
        <p class="text-h5 font-weight-bold neutral100--text">
          {{ $t('ARTWORK.EDIT.WORD.DISPLAY_METHOD') }}
        </p>
        <v-item-group v-model="pickedDisplayType" mandatory>
          <v-row>
            <v-col
              v-for="item in displayTypeOptions"
              :key="`display type:${item.value}`"
            >
              <v-item :value="item.value" #default="{ active, toggle }">
                <v-card
                  class="type_item_card"
                  :class="{ active }"
                  @click="toggle"
                >
                  <v-img :aspect-ratio="16 / 9">
                    <video
                      :src="item.video"
                      autoplay
                      loop
                      muted
                      playsinline
                      class="bg_video"
                    ></video>
                    <span
                      class="display_type_hint neutral600 py-1 px-3 text-no-wrap b-rad-8 opacity--70"
                    >
                      {{ $t(item.texKey) }}
                    </span>
                  </v-img>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>
        <SizeBox height="48" />
      </template>

      <template
        v-if="type === '3dmodel' ? pickedDisplayType === 'image' : true"
      >
        <p class="text-h5 font-weight-bold neutral100--text">
          {{ $t('ARTWORK.EDIT.WORD.PREVIEW') }}
        </p>

        <SimpleFileArea
          v-model="holdingFile"
          :img="previewImg"
          @update-img="(v) => (previewImg = v)"
          :loading="isUploadingPreview"
        />

        <SizeBox height="24" />

        <v-expand-transition>
          <div v-if="type !== '3dmodel' && !!previewImg && false">
            <p class="text-h5 font-weight-bold neutral100--text">展示畫框</p>
            <div class="flex-center">
              <!-- <v-icon :size="32" @click.stop>mdi-arrow-left-circle</v-icon> -->
              <div class="w60p mx-5">
                <v-window v-model="frameIndex" touchless>
                  <v-window-item :value="1">
                    <v-img :src="require(`@/assets/images/frames/gold.png`)" />
                  </v-window-item>
                </v-window>
              </div>
              <!-- <v-icon :size="32" @click.stop>mdi-arrow-right-circle</v-icon> -->
            </div>
          </div>
        </v-expand-transition>
      </template>

      <SizeBox height="24" />
    </v-card-text>
  </v-card>
</template>

<script>
import SimpleFileArea from '@/components/SimpleFileArea.vue';
import { addImageByCategory } from '@/api/panel/images';

export default {
  components: { SimpleFileArea },
  props: {
    previewURL: {
      type: String,
      default: ''
    },
    method: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    displayType: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      holdingFile: null,
      previewImg: this.previewURL,
      pickedDisplayType: this.displayType || 'model', // model, image
      displayTypeOptions: [
        {
          value: 'model',
          text: '用展示台陳列模型',
          video: require(`@/assets/videos/3DUsingStand.mp4`),
          texKey: 'ARTWORK.EDIT.COPYWRITING.DISPLAY_3D_MODELS_ON_A_STAND'
        },
        {
          value: 'image',
          text: '透過展示圖片預覽模型',
          video: require(`@/assets/videos/3DUsingFrame.mp4`),
          texKey: 'ARTWORK.EDIT.COPYWRITING.PREVIEW_THE_MODEL_WITH_IMAGE'
        }
      ],

      frameIndex: 1,
      isUploadingPreview: false
    };
  },

  watch: {
    holdingFile(v) {
      if (!v) this.previewImg = null;
    },
    previewURL(v) {
      this.previewImg = v;
    },
    previewImg(v) {
      this.$emit('change-image', v);
      if (v) this.drawPreviewImage();
    },
    pickedDisplayType(v) {
      this.$emit('pick-display-type', v);
    },
    type(v) {
      this.$emit('change-type', v);
    }
  },

  methods: {
    async uploadPreviewImg(image) {
      const form = new FormData();
      form.append('file', image);

      const typeConvert = {
        image: 'staticArtwork',
        video: 'videoArtwork',
        sound: 'musicArtwork',
        website: 'websiteArtwork',
        '3dmodel': 'modelArtwork'
      };

      const { id, url, error } = await addImageByCategory({
        category: `${typeConvert[this.type]}Preview`,
        data: form
      });

      if (!error) {
        this.$toast(this.$t('ARTWORK.EDIT.TOAST.SUCCESS.UPLOAD_SUCCESSFUL'));
        this.$emit('update-id', id);
      } else {
        this.$toast.error(
          this.$t('ARTWORK.EDIT.TOAST.ALERT.UPLOAD_FAILED') + error.message
        );
        this.holdingFile = null;
      }

      this.isUploadingPreview = false;
    },
    async drawPreviewImage() {
      this.isUploadingPreview = true;

      const { file, imgURL } = await this.$shrinkImg(this.previewImg, {
        minWidth: 280,
        minHeight: 280,
        targetSize: 1048576,
        maxWidth: 1024,
        maxHeight: 1024
      });

      this.uploadPreviewImg(file);
      this.currentFrameImage = imgURL;
    }
  }
};
</script>

<style lang="scss" scoped>
.type_item_card.active {
  border-width: 2px !important;
  border-style: solid !important;
  border-color: $primary !important;
}

.display_type_hint {
  position: absolute;
  bottom: 18px;
  left: 50%;
  transform: translateX(-50%);
}

.bg_video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>